/**
 * Convert WP plain text / line breaks to simple HTML (paragraphs + br).
 */
export function wpContentToHtml(text: string): string {
  if (!text || !text.trim()) return '';
  let s = text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  const blocks = s.split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
  if (blocks.length === 0) return '';
  return blocks
    .map((p) => {
      const withBr = p.split('\n').join('<br />');
      return `<p>${withBr}</p>`;
    })
    .join('\n');
}
